import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'decimalDigits'
})
export class DecimalDigitsPipe implements PipeTransform {
  transform(value: number): string {
    return (value ?? 0).toFixed(2);
  }
}